import { AmazonConnectChatSettings } from "@eisinc/App/Components/XngScriptInjector/utils";
import {
    getSession,
} from "@insite/client-framework/Store/Context/ContextSelectors";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";
import { connect, DispatchProp } from "react-redux";

/* eslint-disable camelcase */
declare let amazon_connect: any;

const enum fields {
}

const mapStateToProps = (state: any) => {
    const session = getSession(state);
    const { amazonConnectChatSettings } = getSettingsCollection(state);

    return {
        firstName: session?.firstName,
        lastName: session?.lastName,
        email: session?.email,
        isAuthenticated: session?.isAuthenticated,
        amazonConnectChatSettings: amazonConnectChatSettings as AmazonConnectChatSettings,
    };
};

type Props = WidgetProps &
    ReturnType<typeof mapStateToProps> &
    DispatchProp<any> & {
        fields: {
        };
    };

const AWSChat: React.FC<Props> = ({
    amazonConnectChatSettings,
    fields: { mixPanelApiKey },
}) => {
    const [isScriptAttached, setIsScriptAttached] = React.useState(false);

    const attachScriptToDocument = () => {
        setIsScriptAttached(true);

        const script = document.createElement('script');
        script.innerHTML = `
            (function (w, d, x, id) {
                s = d.createElement('script');
                s.src = '${amazonConnectChatSettings.amazonChatSource}';
                s.async = 1;
                s.id = id;
                d.getElementsByTagName('head')[0].appendChild(s);
                w[x] = w[x] || function () { (w[x].ac = w[x].ac || []).push(arguments) };
            })(window, document, 'amazon_connect', '${amazonConnectChatSettings.widgetId}');
            
            amazon_connect('styles', { iconType: 'CHAT_VOICE', openChat: { color: '#ffffff', backgroundColor: '#35a1a8' }, closeChat: { color: '#ffffff', backgroundColor: '#35a1a8' } });
            amazon_connect('snippetId', '${amazonConnectChatSettings.snippetId}');
            amazon_connect('supportedMessagingContentTypes', ['text/plain', 'text/markdown', 'application/vnd.amazonaws.connect.message.interactive', 'application/vnd.amazonaws.connect.message.interactive.response']);
        `;

        document.head.appendChild(script);
    };

    React.useEffect(() => {
        if (amazonConnectChatSettings?.amazonChatSource && amazonConnectChatSettings?.snippetId && !isScriptAttached) {
            attachScriptToDocument();
        }
    }, [amazonConnectChatSettings]);

    React.useEffect(() => {
        if (isScriptAttached && typeof amazon_connect !== 'undefined') {
            amazon_connect('authenticate', function (callback: any) {
                fetch(`/api/custom/amazonChat/token?currentPage=${window?.location?.pathname}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                    .then(response => response.json())
                    .then(data => {
                        callback(data.data);
                    }).catch(error => {
                        console.error('Error fetching token:', error);
                    });
            });
        }
    }, [isScriptAttached]);

    return <></>;
};

const definition: WidgetDefinition = {
    group: "Common",
    displayName: "AWS Chat Widget",
    allowedContexts: ["Header"],
    fieldDefinitions: [
    ],
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(AWSChat),
    definition,
};

export default widgetModule;
